'use strict';/* global define:false */define('modules/360-feedback/directives/360-feedback/index',['text!./template.html','./controller'],function(template,controller){'use strict';function directive(){return{restrict:'E',template:template,replace:true,controller:controller,controllerAs:'FeedbackCtrl',scope:{feedback:'=',readonly:'='}};}// directive.$inject = [
//
// ];
return directive;});
